var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "line-height": "0.7", "min-height": "29px" },
      style: { "-w": _vm.inputWidth },
    },
    [
      _c(
        "el-select",
        {
          ref: "vueSelect",
          staticClass: "vue-select-page",
          style: { "--width": _vm.inputWidth + "px" },
          attrs: {
            multiple: _vm.multiple,
            filterable: _vm.filterable,
            remote: _vm.remote,
            clearable: _vm.clearable,
            placeholder: _vm.placeholder,
            "collapse-tags": _vm.collapse,
            "filter-method": _vm.filterMethod,
            "popper-class": !_vm.paging
              ? "select-page"
              : "select-page select-page-padding",
            "reserve-keyword": true,
            disabled: _vm.selectDisabled,
          },
          on: {
            change: _vm.handleChange,
            "visible-change": _vm.handleVisibleChange,
            "remove-tag": _vm.onRemoveTag,
            clear: _vm.onClear,
            blur: _vm.onBlur,
            focus: _vm.onFocus,
          },
          model: {
            value: _vm.selectedValue,
            callback: function ($$v) {
              _vm.selectedValue = $$v
            },
            expression: "selectedValue",
          },
        },
        [
          _c(
            "div",
            _vm._l(_vm.curOptions, function (item) {
              return _c("el-option", {
                key: item[_vm.valueKey],
                attrs: {
                  label: _vm.returnItemLabel(item),
                  value: item[_vm.valueKey],
                  disabled: item[_vm.disabledKey],
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.paging,
                  expression: "paging",
                },
              ],
              staticClass: "select-pagination",
            },
            [
              _c(
                "el-pagination",
                {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-size": _vm.pageSize,
                    total: _vm.total,
                    small: "",
                    layout: "total, prev, slot, next, jumper",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function ($event) {
                      _vm.currentPage = $event
                    },
                    "current-change": _vm.handleCurrentChange,
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.currentPage) +
                        " / " +
                        _vm._s(Math.ceil(_vm.total / _vm.pageSize))
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }